
import { Menu } from "react-admin";
import FolderIcon from "@mui/icons-material/Folder";
import { useLocation } from "react-router-dom";


const AdminMenu = () => {
  const location = useLocation();

  return (
    <Menu>
      <Menu.Item
        to="/admin/documents"
        primaryText="Documents"
        leftIcon={<FolderIcon />}
        // highlight active state
       
      />

     <Menu.ResourceItem name="news" />
     <Menu.ResourceItem name="announcements" />
    </Menu>
  );
};

export default AdminMenu;

